/** 整体布局*/
import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';

export const App: React.FC = () => {
  const { pathname } = useLocation();

  // 首页、阅读、笔顺练习、CRX 产品页等使用全屏布局，不套用 Host 调试导航外壳
  if (
    pathname === '/' ||
    pathname.startsWith('/read') ||
    pathname.startsWith('/write') ||
    pathname.startsWith('/flow') ||
    pathname.startsWith('/rich') ||
    pathname.startsWith('/crx') ||
    pathname.startsWith('/showcase/')
  ) {
    return <Outlet />;
  }

  return (
    <div className="p-4">
      <Outlet />
    </div>
  );
};

export default App;
